import React, { useEffect } from "react";
import HTMLReactParser from "html-react-parser";
import Reach from "/fallbacks/reach.svg";

const withReach = ({ type, environment, text }) => {
  useEffect(() => {
    const links = document.getElementsByClassName("reach--inline-link");
    links &&
      Array.from(links).forEach((item) => {
        item.setAttribute("href", "/legal/reach");
      });
  });
  switch (environment) {
    case "global":
      return (
        <section className="withReach withReach--global">
          <div className="withReach__wrapper">
            {Reach && (
              <img className="withReach__icon" src={Reach} alt={`${general_settings.brand_name} Reach Verified`} />
            )}
            <div className="withReach__seperator"></div>
            <article className="withReach__text">{text && HTMLReactParser(text)}</article>
          </div>
        </section>
      );
    default:
      return (
        <section
          className={`${type == "accordion" ? "withReach--accordion" : "withReach--classic"} withReach`}
          style={environment == "local" && type != "accordion" ? { marginBottom: "16px" } : {}}
        >
          <div className="withReach__wrapper">
            <img className="withReach__icon" src={Reach} alt={`${general_settings.brand_name} Reach Verified`} />
            <div className="withReach__seperator"></div>
            <article className="withReach__text">{text && HTMLReactParser(text)}</article>
          </div>
        </section>
      );
  }
};

export default withReach;
